module.exports = __webpack_public_path__ + "img/contact_banner_01.74a0d3c7.png";